<page-header title="შეფასების შაბლონები">
    <button mat-icon-button class="add-button" aria-label="add" matTooltip="შაბლონის დამატება" (click)="add()">
        <mat-icon>add</mat-icon>
    </button>
</page-header>

<mat-list>
    @for (template of templates; track template._id) {
        <mat-list-item class="clickable" (click)="edit(template)">
            <span matListItemTitle>{{ template.name }}</span>
            <span matListItemLine>{{ template.code }}</span>
            <span matListItemLine>{{ template.description }}</span>
            <span matListItemMeta class="row-actions">
                <button
                    mat-icon-button
                    aria-label="linked activations"
                    matTooltip="დაკავშირებული უწყისები"
                    (click)="viewActivations(template); $event.stopPropagation()"
                >
                    <mat-icon>list</mat-icon>
                </button>
                <button
                    mat-icon-button
                    aria-label="edit details"
                    matTooltip="დეტალების რედაქტირება"
                    (click)="changeDetails(template); $event.stopPropagation()"
                >
                    <mat-icon>edit</mat-icon>
                </button>
                <button
                    mat-icon-button
                    aria-label="delete"
                    matTooltip="წაშლა"
                    (click)="remove(template); $event.stopPropagation()"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </span>
        </mat-list-item>
    } @empty {
        <div class="empty-state">შაბლონები არ მოიძებნა</div>
    }
</mat-list>
